module.exports = __webpack_public_path__ + "img/img11.a3d9ad60.png";